import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { 
    Modal, 
    Form, 
    Input, 
    Select, 
    message, 
    Spin, 
    List, 
    Button, 
    Popconfirm,
    Card,
    Row,
    Radio,
    Popover,
    Divider,
} from 'antd'

import Hotkeys from 'react-hot-keys'

import InfiniteScroll from 'react-infinite-scroller'
import debounce from 'debounce'

import { 
    _postCreateInvoice,
    _postCreateOrderConfirmation,
    _postQbFindCustomers,
    _postQbCreateCustomer,
    _postQbSetBuyerId,
    _postSendManualInvoice,
    _postCheckAndSetBuyerId
} from '../../services';

const { Item } = Form;
const { Option } = Select;
const { Search } = Input;
const RadioGroup = Radio.Group

class ClaimModal extends React.Component{

    
    render(){

        const invoiceSentBefore = this.props.order.lastContact.invoiceDate

        return(
            <Hotkeys
                keyName="enter"
                onKeyDown={this.handleOk}
                >
            <Modal 
                visible={this.state.visible}
                onOk={this.handleOk}
                onKey
                onCancel={this.closeModal}
                title="Make Claim"
                footer={
                    <div style={{display: 'flex'}}>
                        <div>
                            {!invoiceSentBefore && this.renderSendInvoiceButton()}
                        </div>
                        <div style={{ marginLeft: 'auto' }}>
                            <Button key="back" onClick={this.closeModal}>
                                Cancel
                            </Button>
                            <Button key="submit" type="primary" onClick={this.handleOk}>
                                Ok
                            </Button>
                        </div>
                    </div>
                  }
                >
                {this.renderForm()}
            </Modal>
            </Hotkeys>
        )
    }

    constructor(props){
        super(props);
        
        this.state = {
            visible:this.props.visible,
            refNumber: this.props.order.adminControls.offlineReferenceNumber,
            invalidRefNumber:"error",
            orderType:"online",
            data:false,
            setQbIdLoading:false,
            claimLoading:false,
            loading:false,
            hasMore:true,
            pageNumber:0,
            searchTerm: '',
            quickbooksId:false,
            quickbooksDisplayName:false,
            deliveryModalVisible:false,
            qbCustomerNameType:"companyName"
        }

        this.handleSearch = debounce(this.handleSearch, 200);


    }

    componentDidMount(){

        Promise.all([
            _postQbFindCustomers(this.state.pageNumber, this.state.searchTerm),
            _postCheckAndSetBuyerId({ cartId: this.props.order._id })
        ]) 
        .then(([_qbCustomers, _checkBuyerId]) => {

            this.setState({data: _qbCustomers.data.customers})

            console.log({_checkBuyerId})

            if (_checkBuyerId.data.success) {
                this.props.refreshOrderData(this.props.order._id)
                this.closeModal()
            }
            
        })
        .catch(err => console.log(err))

        if(this.props.order.user.quickbooks && this.props.order.user.quickbooks.buyer){
            this.setState({
                quickbooksId: this.props.order.user.quickbooks.buyer.id,
                quickbooksDisplayName: this.props.order.user.quickbooks.buyer.displayName
            })
        }

        
    }

    renderSendInvoiceButton = () => {
        return (
            <Popconfirm
            title='Are you sure you want to send the invoice?'
            onConfirm={() => this.handleSendInvoice()}
            okText="Yes" 
            cancelText="No">
                <Button key="invoice">
                    Send Invoice
                </Button>
            </Popconfirm>
        )
    }

    handleSendInvoice = () => {
        _postSendManualInvoice({cartId: this.props.order._id})
        .then(_cart => {
            if (_cart.data.success) {
                message.success(_cart.data.msg, 10)
                this.props.refreshOrderData(this.props.order._id)
            } else {
                message.warning(_cart.data.msg, 10)
                this.props.refreshOrderData(this.props.order._id)
            }
        })
    }
    
    handleConfirmCreateCustomer=()=>{   

        const { activeShipping, activeBilling } = this.props.order

        let type = this.state.qbCustomerNameType

        let qbCustomerName

        if (activeBilling){
            if( activeBilling.sameAsShipping ){
                qbCustomerName = activeShipping[type]
            } else {
                qbCustomerName = activeBilling[type]
            }
        } else {
            qbCustomerName = activeShipping[type]
        }

        _postQbCreateCustomer(this.props.order._id, qbCustomerName)
        .then( res => {
            if(res.data.success){
                let quickbooksId = res.data.quickbooks.buyer.id
                let quickbooksDisplayName = res.data.quickbooks.buyer.displayName
    
                this.handleSetQuickbooksId(quickbooksId, quickbooksDisplayName)
            } else{
                // console.log(res.data.err)
                message.error(res.data.err.Fault.Error[0].Message)
            }
        })
    }

    handleOnChangeQbCustomerNameType = (e) =>{
        this.setState({qbCustomerNameType:e.target.value})
    }
    
    handleOnSearchChange = (e) => {

        if(!e){
            return
        } else {
            this.handleSearch(e.target.value)
        }
    }

    handleSearch = ( searchTerm ) => {
      
        this.setState({
            pageNumber:0,
            searchTerm,
            hasMore:true,
            loading:true
        },()=>{
                _postQbFindCustomers(this.state.pageNumber, this.state.searchTerm)
                .then(res => {

                    if(res.data.customers.length === 0){
                        message.warning("Loaded all customers")
                    }

                    this.setState({
                        data:res.data.customers,
                        loading:false
                    })
                })
            }
        )
    }

    handleInfiniteOnLoad = () => {
        
        let data = this.state.data;

        this.setState({
          loading: true,
          pageNumber:this.state.pageNumber + 1
        });

        // if (data.length < 19) {
        //     message.warning('Infinite List loaded all');
        //     this.setState({
        //       hasMore: false,
        //       loading: false,
        //     });
        //     return;
        //   }

        _postQbFindCustomers(this.state.pageNumber, this.state.searchTerm)
        .then(res => {
            if(res.data.customers.length === 0){
                message.warning("Loaded all customers")
                this.setState({
                    hasMore: false,
                    loading: false
                })

            } else {
                data = data.concat(res.data.customers)
                this.setState({
                    data,
                    loading:false
                })
            }
        })
      }

    handleOk=()=>{
        
        if(this.state.quickbooksId){
            let cartId = this.props.order._id;
            let offlineReferenceNumber = this.state.refNumber;
            let orderType = this.state.orderType;

            this.setState({claimLoading:true})
    
            // _postCreateInvoice({
            //     cartId,
            //     offlineReferenceNumber,
            //     orderType
            // })
            _postCreateOrderConfirmation({
                cartId,
                offlineReferenceNumber,
                orderType
            })
            .then(res => {

                if(res.data.success){

                    this.props.handleClaimOrder(this.props.order)
                    this.closeModal()
        
                    message.success(offlineReferenceNumber + " claimed")
                } else {
                    // console.log(res.data)
                    message.error(res.data.err.Fault.Error[0].Message)
                    // message.error("Error!")
                }
    
            })
            .catch(err => message.error("Error"))

        }

        // if(this.state.refNumber.length < 12){
        //     message.warning("Invalid reference number!")
        // }
        if(!this.state.quickbooksId){
            message.warning("Please assign quickbooks information!")
        }



    }
    
    closeModal=()=>{
        this.setState({visible:false});
        this.props.closeClaimModal();
    }

    handleInputRefNumber=(e)=>{
        
        let refNumber;

        refNumber = e.target.value;

        
        this.setState({
            refNumber
        })

    }

    handleSelectOrderOption=(e)=>{
        
        this.setState({orderType:e})

    }

    handleSetQuickbooksId=(quickbooksId, quickbooksDisplayName)=>{

        this.setState({setQbIdLoading:true})

        _postQbSetBuyerId({
            quickbooksId, 
            quickbooksDisplayName, 
            cartId:this.props.order._id
        })
        .then( res => {

            this.setState({setQbIdLoading:false})

            if(res.data.success){
                this.setState({
                    quickbooksId:res.data.user.quickbooks.buyer.id,
                    quickbooksDisplayName: res.data.user.quickbooks.buyer.displayName
                })
                message.success("Quickbooks information assigned!")
            } else{
                console.log("Error", res.data.err)
                message.error("Error!")
            }
        })
    }

    renderCustomerForm = () =>{
        return(
            <div>fuck</div>
        )
    }

    renderForm=()=>{

        let order = this.props.order;

        let activeBillingDeliveryunit = ""
        if (order.activeBilling && order.activeBilling.unit) {
            if (order.activeBilling.unit.includes('#')) { activeBillingDeliveryunit = order.activeBilling.unit }
            if (!order.activeBilling.unit.includes('#')) { activeBillingDeliveryunit = `#${order.activeBilling.unit}` }
        }
        let activeBillingAddress = `${order.activeShipping.address} ${activeBillingDeliveryunit}`
        let activeShippingDeliveryunit = ""
        if (order.activeShipping && order.activeShipping.unit) {
            if (order.activeShipping.unit.includes('#')) { activeBillingDeliveryunit = order.activeShipping.unit }
            if (!order.activeShipping.unit.includes('#')) { activeBillingDeliveryunit = `#${order.activeShipping.unit}` }
        }
        let activeShippingAddress = `${order.activeShipping.address} ${activeShippingDeliveryunit}`

        return (
            <Form>
                <Row style={{ marginBottom: 8 }}>
                    <span style={{ marginLeft: 4, fontWeight: 500 }}>Billing: </span> {activeBillingAddress || "-"}
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <span style={{ marginLeft: 4, fontWeight: 500 }}>Shipping: </span> {activeShippingAddress || "-"}
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <span style={{ marginLeft: 4, fontWeight: 500 }}>Company name: </span> {order.activeShipping.companyName || "-"}
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <span style={{ marginLeft: 4, fontWeight: 500 }}>Name: </span>{order.user.details.name || order.activeShipping.name || "-"}
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <span style={{ marginLeft: 4, fontWeight: 500 }}>Email: </span>{order.user.details.email || order.user.local.email || "-"}
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <span style={{ marginLeft: 4, fontWeight: 500 }}>Quickbooks name: </span>{this.state.quickbooksDisplayName ? this.state.quickbooksDisplayName : "-"}
                    {this.state.quickbooksDisplayName &&
                        <Button
                            onClick={this.handleChangeQbCustomer}
                            style={{
                                height: 20,
                                fontSize: 10,
                                marginLeft: 20
                            }}
                            type="danger">Remove</Button>
                    }
                </Row>
                <Divider />
            {!this.state.claimLoading?
            <div>
                {this.props.user.data.permissions.ezOperations && 
                <div>
                    <span>Existing reference: {order.adminControls.offlineReferenceNumber}</span>
                    {/* {order.adminControls.offlineReferenceNumber?
                    <span>Existing reference: {order.adminControls.offlineReferenceNumber}</span>
                    :null
                    }
                    <Item
                        // validateStatus={this.state.invalidRefNumber}
                        >
                        <Input
                            onPressEnter={this.handleOk}
                            placeholder="INV-YYMM-XXX"
                            defaultValue={this.state.refNumber}
                            onChange={this.handleInputRefNumber}
                            />
                    </Item> */}
                </div>}

                <Item>
                   <Select
                        onChange={this.handleSelectOrderOption}
                        defaultValue="online">
                        <Option value="online">Online</Option>
                        <Option value="phone">Phone</Option>
                        <Option value="email">Email</Option>
                        <Option value="whatsapp">Whatsapp</Option>
                    </Select>
                </Item>
                {!this.state.quickbooksId?
                    <Item>
                        <Card
                            title={(<Search 
                                onChange={this.handleOnSearchChange}
                                placeholder="Search company name"
                                // onSearch={this.handleOnSearch}
                            />)}
                        >
                    {/* </Item> */}
                    {/* <Item> */}
                        <div  
                            style={{
                                    border: "1px solid #e8e8e8",
                                    borderRadius: 4,
                                    padding: "8px 24px",
                                    height:300,
                                    overflow:"auto"
                                }}>
                        {this.state.data
                        ?
                        <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={this.handleInfiniteOnLoad}
                        hasMore={!this.state.loading && this.state.hasMore}
                        useWindow={false}
                        >
                        <List
                            dataSource={this.state.data}
                            renderItem={item=>(
                                <Popconfirm
                                title={<div><span>Link {item.DisplayName} to this customer?</span><br/><span>This cannot be undone.</span></div>}
                                onConfirm={()=>this.handleSetQuickbooksId(item.Id, item.DisplayName) }
                                okText="Yes" 
                                cancelText="No">
                                <List.Item  
                                    style={{cursor: "pointer"}}
                                    key={item.Id}>
                                    <div>{item.DisplayName}</div>
                                </List.Item>
                                </Popconfirm>
                            )}
                            >
                            {this.state.loading && this.state.hasMore && (
                            <div style={{textAlign:"center"}}>
                                <Spin />
                            </div>
                            )}
                        </List>
                        </InfiniteScroll>
                    
                        :
                        <div style={{textAlign:"center"}}>
                            <Spin />
                        </div>
                        }
                        </div>
                        <div style={{textAlign:"center"}}>
                        <div>or</div>
                        <Popover 
                            trigger="click"
                            title={<Row type="flex" justify="center">Use {this.props.order.user.details[this.state.qbCustomerNameType] || this.props.order.activeShipping[this.state.qbCustomerNameType]} for Quickbooks</Row>}
                            style={{width:250}}
                            content={(
                                <Row>
                                    <Row>
                                        {this.renderQbCustomerTypesRadio()}
                                    
                                    </Row>
                                    <Row type="flex" justify="center">
                                        <Button type="primary" onClick={this.handleConfirmCreateCustomer}>Confirm</Button>
                                    </Row>
                                </Row>
                            )}
                           >
                           {this.state.setQbIdLoading?
                            <Spin/>
                           :
                            <Button>Create Quickbooks Customer</Button>
                           }
                        </Popover>
                        </div>
                        </Card>
                    </Item>
                :
                    null
                }
                </div>:
                <div style={{width:"100%", textAlign:"center"}}>
                <Spin/>
                </div>
                }
            </Form>
        )
    }

    handleChangeQbCustomer = () => {
        this.setState({
            quickbooksId: false,
            quickbooksDisplayName: false
        })
    }

    renderQbCustomerTypesRadio = () => {
        
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };

        let isEnterpriseOrder = Boolean(this.props.order.enterpriseId)

        if (isEnterpriseOrder) {
            return (
                <RadioGroup onChange={this.handleOnChangeQbCustomerNameType} value={this.state.qbCustomerNameType}>
                    <Radio style={radioStyle} value={"companyName"}>Company Name</Radio>
                </RadioGroup>
            )
        }
         
        return (
            <RadioGroup onChange={this.handleOnChangeQbCustomerNameType} value={this.state.qbCustomerNameType}>
                <Radio style={radioStyle} value={"name"}>Buyer Name</Radio>
                <Radio style={radioStyle} value={"email"}>Email</Radio>
            </RadioGroup>
        )
    }


}

export default connect(
	state => ({
		user: state.user
	})
)( withRouter(ClaimModal) );



// WEBPACK FOOTER //
// ./src/components/orders-v2/claim-modal.js